import {AfterContentInit, ChangeDetectorRef, Component} from '@angular/core';
import {FieldType, FieldTypeConfig} from '@ngx-formly/core';
import moment from 'moment';

// @Component({
//   selector: 'app-form-datepicker-type',
//   template: `
//     <input matInput
//       [errorStateMatcher]="errorStateMatcher"
//       [formControl]="formControl"
//       [matDatepicker]="picker"
//       [matDatepickerFilter]="to.datepickerOptions.filter"
//       [formlyAttributes]="field">
//     <ng-template #matSuffix>
//       <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
//     </ng-template>
//     <mat-datepicker #picker></mat-datepicker>
//   `,
// })

@Component({
  selector: 'app-form-datepicker-type',
  template: `
    <mat-form-field class="w100" appearance="outline">
      <mat-label>{{ field.templateOptions.label }}</mat-label>
      <input [maxLength]="10"
             [id]="field.templateOptions.id"
             type="text" [formControl]="field.formControl"
             matInput (ngModelChange)="dateChange($event)" [(ngModel)]="date">
      <mat-error *ngIf="field.formControl.errors?.incorrect">
        Дата не верна
      </mat-error>
    </mat-form-field>

  `,
})

export class DatepickerTypeComponent extends FieldType<FieldTypeConfig> implements AfterContentInit {
  date: string = '';
  previous = '';
  error = false;
  override field: any | undefined;

  constructor(
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterContentInit() {
    this.date = moment(this.field.formControl.value).format('DD.MM.YYYY');
  }

  validate_date(userValue: string) {
    let month = userValue.substring(3, 5);
    if (month.indexOf('0') === 1) {
      month = month.split('')[1];
    }
    if (+month > 12 || month === '00') {
      return true;
    }
    const mo: any = moment(userValue, 'DD.MM.YYYY');
    return !mo._isValid;
  }

  dateChange(event: any) {

    if (!event || event && event.length === 0) {
      return;
    }

    if (this.previous.length < event.length) {
      if (event.length === 2 || event.length === 5) {
        event += '.';
      }
      setTimeout(() => {
        this.date = event;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }, 1);
    }


    this.previous = event;

    setTimeout(() => {
      this.field.formControl.markAsTouched();
      if (event.length === 10) {
        this.error = this.validate_date(this.date);
        if (this.error) {
          // console.log('Дата не валидная');
          this.field.formControl.setErrors({incorrect: true});
        } else {
          this.field.formControl.setValue(this.date);
        }
      } else {
        this.field.formControl.setErrors({incorrect: true});
      }
    }, 500);


  }
}
